import React, { useEffect, useState } from 'react'
import DataTable from 'react-data-table-component';
import { useAlert } from "react-alert";
import { confirmAlert } from "react-confirm-alert";

export default function AddRubros() {
    const [name, setname] = useState("");
    const [id, setid] = useState(0);
    const [rubros, setrubros] = useState([]);
    let alert = useAlert();

    useEffect(() => {
        getRubro()
    }, [])

    const columns = [
        {
            name: 'Nombre',
            selector: row => row.name,
        },
        {
            name: "Editar",
            button: "true",
            cell: (row) => (
                <>
                    <button className="btn btn-primary" onClick={() => { editRubro(row.idrubro, row.name) }}>Editar</button>
                </>
            ),
        },
        {
            name: "Eliminar",
            button: "true",
            cell: (row) => (
                <>
                    <button className="btn btn-danger" onClick={() => { deleteRubro(row.idrubro, row.name) }}>Eliminar</button>
                </>
            ),
        },
    ];

    const getRubro = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getRubro`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setrubros(data);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los rubros", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }

    const saveRubro = () => {
        if (!name) {
            return;
        }

        fetch(`${process.env.REACT_APP_URL_API}/data/saveRubro`, {
            method: "POST",
            mode: "cors",
            headers: {
                "Cache-Control": "no-cache",
                "Access-Control-Allow-Origin": "*",
            },
            body: JSON.stringify({ name, id }),
        }).then((response) => response.json())
            .then((datar) => {
                if (datar.rows > 0) {
                    alert.show("Datos Guardados", {
                        timeout: 2000,
                        type: "success",
                        onClose: () => {
                            getRubro()
                            setname("")
                            setid(0)
                        },
                    });
                } else {
                    alert.show(
                        "Ocurrió un error al guardar los datos, por favor intenta de nuevo",
                        {
                            timeout: 3000,
                            type: "error",
                        }
                    );
                }
            })
            .catch((error) => {
                alert.show(
                    "Ocurrió un error al guardar los datos, por favor intenta de nuevo " +
                    error,
                    {
                        timeout: 3000,
                        type: "error",
                    }
                );
            });
    }

    const editRubro = (id, name) => {
        setname(name);
        setid(id);
    }

    const deleteRubro = (id, name) => {
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className="AlertUI DangerAlert">
                        <h1>Aviso</h1>
                        <p>
                            {`¿Deseas eliminar el rubro ${name}?`}
                        </p>
                        <button onClick={onClose}>No</button>
                        <button
                            onClick={() => {
                                fetch(`${process.env.REACT_APP_URL_API}/data/deleteRubro`, {
                                    method: "POST",
                                    mode: "cors",
                                    headers: {
                                        "Cache-Control": "no-cache",
                                        "Access-Control-Allow-Origin": "*",
                                    },
                                    body: JSON.stringify({ id: id }),
                                })
                                    .then((response) => response.json())
                                    .then((datar) => {
                                        if (datar.rows > 0) {
                                            alert.show("Rubro Eliminado", {
                                                timeout: 3000,
                                                type: "success",
                                                onClose: () => {
                                                    setrubros(rubros.filter((item, ind) => (item.idrubro !== id)));
                                                    onClose();
                                                },
                                            });
                                        }
                                    })
                                    .catch((error) => {
                                        alert.show(
                                            "Ocurrió un error al borrar el rubro, por favor intenta de nuevo: " +
                                            error,
                                            {
                                                timeout: 3000,
                                                type: "error",
                                            }
                                        );
                                    });
                            }}
                        >
                            Si
                        </button>
                    </div>
                );
            },
        });
    }

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <div>
            <div className="row">
                <p className='text-center'>Agrega o modifica los rubros</p>
            </div>
            <div className="row">
                <div className="col-md-10">
                    <input type="text" value={name} onChange={(e) => { setname(e.target.value) }} className="form-control" placeholder='Nombre Rubro' />
                </div>
                <div className="col-md-2">
                    <button className="btn btn-success" onClick={() => {
                        setid(0)
                        saveRubro()
                    }}>Guardar</button>
                </div>
            </div>
            <div className="pt-2">
                <DataTable
                    columns={columns}
                    noDataComponent="Sin datos que mostrar"
                    data={rubros}
                    paginationComponentOptions={paginationComponentOptions}
                    pagination
                />
            </div>
        </div>
    )
}
